import React from 'react';

const QuerySelectorComponent = (props) => {
  return (
    props.questions ?
      <>
        <label className="quesHeading text-left"> {props.queryHeading ? props.queryHeading : ''} </label>
        <ul className="list-group list-group-flush text-left" id="queryList">
          
          {props.questions.map((question, index) =>
            <li key={index} className="list-group-item" onClick={props.nextQuestion.bind(this, question)}>
              <span className="question">{(question.value) ? question.value : ''}</span> <span className="pull-right">
                <img src="/images/icon_right_gray.png" className="icon_right_gray" alt="right arrow" />
              </span>
            </li>
          )}
        </ul>
      </>
      : ''
  )
};

export default QuerySelectorComponent;